import React from "react";
import { Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";


import { AddOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../../hooks";
import { LoadState } from "../../../../../../../constants/enums";
import { IAutomobileDriverClaims } from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import {
  addAutomobileDriverClaimAsync,
  clearAutomobileClaimInfo,
  fetchAutomobileDriverClaimsListAsync,
} from "../../../../../../../redux/automobileDriver/automobileDriverActions";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import { useTableV2State } from "../../../../../../../components/TableV2/hooks/useTableV2State";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { StatusRenderer } from "../../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { PageTitleBar } from "../../../../../../../components/PageTitleBar/PageTitleBar";
import { DataTableV2 } from "../../../../../../../components/TableV2/DataTableV2";
import { downloadClaimsPDFAsync, previewClaimsPDFAsync } from "../../../../../../../redux/claims/claimsActions";
import { ConfirmDialog } from "../../../../../../../components/Dialogs/ConfirmDialog";

export const AutomobileDriverClaimsList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { driverClaimsList, loading } = useSelector(
    (storeState: IStoreState) => storeState.automobile.driver.driverClaims
  );

  const dispatch = useDispatchWrapper();
  const [deleteConfirm, setDeleteConfirm] = React.useState<IAutomobileDriverClaims | null>(null);

  // const [status, setStatus] = React.useState<"ACTIVE" | "INACTIVE" | "-1">(
  //   "-1"
  // );

  const {
    state: { dateState, searchState, tabs, columnsConfig,
      dense },
    setDateState,
    setSelectedTab,
    setTableTabs,
    setSearchState,
    setColumnVisibility,

    onDenseToggle, } = useTableV2State({
      filtersInitialState: {
        defaultDateRange: "allTimes",
        selectedTab: "-1",
      },
    });

  const handleCreate = () => {
    navigate(
      `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/claims`
    );
  };

  const fetchList = () => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileDriverClaimsListAsync(customerPolicyId));
    }
  };

  const handleDelete = () => {
    if (deleteConfirm) {
      dispatch(
        addAutomobileDriverClaimAsync(
          { ...deleteConfirm, status: "INACTIVE" },
          customerId,
          (isSuccess) => {
            if (isSuccess) {
              fetchList();
            }
            setDeleteConfirm(null);
          }
        )
      );
    }
  };

  React.useEffect(() => {
    fetchList();

    return () => {
      dispatch(clearAutomobileClaimInfo());
    };
  }, [customerPolicyId]);

  const automobileDriverTableProps: IDataTableV2Props = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {},
      rightItems: {
        customPlugins: [
          // {
          //   key: "status",
          //   onRender: () => (
          //     <ControlledCustomSelect
          //       fullWidth
          //       value={status}
          //       name="status"
          //       onChange={(e) => setStatus(e.target.value as "ACTIVE")}
          //       placeholder="Select one"
          //       displayEmpty
          //       options={COMMON_STATUS}
          //     />
          //   ),
          // },
        ],
      },
    },
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileDriverClaims) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/claims/${row.incremental_number}`
                );
              }}
              onDeleteClick={() => setDeleteConfirm(row)}
              onDownloadPreview={
                () => {
                  dispatch(
                    previewClaimsPDFAsync(
                      row.customer_policy_id as any,
                      row.incremental_number as any
                    )
                  );
                }
              }
              onDownLoadClick={
                () => {
                  dispatch(
                    downloadClaimsPDFAsync(
                      row.customer_policy_id as any,
                      row.incremental_number as any
                    )
                  );
                }
              }
            />
          );
        },
      },
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 20,
        onRowCellRender: (value, row: IAutomobileDriverClaims) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/claims/${row.incremental_number}`
                );
              }}
            >
              {row.incremental_number}
            </Link>
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileDriverClaims) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "driver_number",
        headerName: "Driver Number",
        fieldName: "driver_number",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
        onRowCellRender: (value, row: IAutomobileDriverClaims) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/claims/${row.incremental_number}`
                );
              }}
            >
              {row.driver_number}
            </Link>
          );
        },
      },

      {
        key: "vehicle_number",
        headerName: "Vehicle Number",
        fieldName: "vehicle_number",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
        onRowCellRender: (value, row: IAutomobileDriverClaims) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/claims/${row.incremental_number}`
                );
              }}
            >
              {row.vehicle_number}
            </Link>
          );
        },
      },
      {
        key: "claim_type",
        headerName: "Type",
        fieldName: "claim_type",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "amount_paid",
        headerName: "Amount Paid",
        fieldName: "amount_paid",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "insurer",
        headerName: "Insurer",
        fieldName: "insurer",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "at_fault",
        headerName: "At Fault",
        fieldName: "at_fault",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "forgiven",
        headerName: "Forgiven",
        fieldName: "forgiven",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "date_of_loss",
        headerName: "Date of Loss",
        fieldName: "date_of_loss",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.DATE_DARK_COLOR,
      },
      {
        key: "insert_ts",
        headerName: "Date Modified",
        fieldName: "insert_ts",
        renderType: DataTableV2RowRenderType.DATE_TIME,
      },
    ],
    rows: driverClaimsList || [],
    dense: dense,
    onDenseToggle: onDenseToggle,
  };

  return (
    <>
      <PageTitleBar
        heading="Automobile Loss Notice"
        rightHeading={
          <Button
            variant="contained"
            onClick={handleCreate}
            startIcon={<AddOutlined />}
          >
            Create
          </Button>
        }
      />
      <DataTableV2 {...automobileDriverTableProps} />
      {deleteConfirm && (
        <ConfirmDialog
          open={true}
          content="Are you sure you want to delete this claim?"
          onConfrim={handleDelete}
          onClose={() => setDeleteConfirm(null)}
        />
      )}
    </>
  );
};
